<template>
  <div class="tw-flex tw-flex-col tw-gap-6">
    <slot />
  </div>
</template>
